import "./TaskViewSwitcher.css";

import React from "react";

import { TASKS_DASHBOARD_VIEWS } from "../../constants";
import { TasksDashboardVariant, TasksDashboardView } from "../../models";

interface TaskViewSwitcherProps {
  variant: TasksDashboardVariant;
  current: TasksDashboardView;
  /** Disable switching (e.g. while the board is loading). */
  disabled?: boolean;
  onChange: (view: TasksDashboardView) => void;
}

export const TaskViewSwitcher = ({
  variant,
  current,
  disabled = false,
  onChange,
}: TaskViewSwitcherProps): JSX.Element => (
  <div className={`TaskViewSwitcher TaskViewSwitcher_${variant}`} role="tablist" aria-label="Task view">
    {TASKS_DASHBOARD_VIEWS.map(({ view, label }) => {
      const isActive = view === current;

      const handleActivate = (): void => {
        if (!disabled && !isActive) onChange(view);
      };

      return (
        <button
          key={view}
          type="button"
          role="tab"
          aria-selected={isActive}
          disabled={disabled}
          className={["TaskViewSwitcher_tab", isActive ? "TaskViewSwitcher_tab_active" : ""].filter(Boolean).join(" ")}
          onClick={handleActivate}
          onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleActivate();
            }
          }}
        >
          {label}
        </button>
      );
    })}
  </div>
);
